<script setup lang="ts">
const youShouldAskLoaded = inject('youShouldAskLoaded', () => ref(false))
const youShouldAskIsLoadedCorrectly = ref(false)

const question = ref('')
const input = useTemplateRef<HTMLInputElement>('input')

const ask = () => {
  window?.ysa_openChat()
  window?.ysa_waitForInitedAndMessage(question.value)

  if (input) {
    input.value?.blur()
  }

  // ysa_waitForInitedAndMessage
  // window.sendMessage(question.value)
  // window.sendMessage()
}

watchEffect(() => {
  if (youShouldAskLoaded.value && !!window?.ysa_openChat) {
    youShouldAskIsLoadedCorrectly.value = true
  }
})
</script>

<template>
  <section
    class="you-should-ask content-type content-type--large-column"
    :class="{ 'you-should-ask--open': youShouldAskIsLoadedCorrectly }"
  >
    <div class="content-type__container">
      <div class="content-type__content">
        <UiHeading class="content-type__heading">
          Hoe kunnen we je helpen?
        </UiHeading>
      </div>

      <div class="content-type__content">
        <form
          class="you-should-ask__form"
          method="post"
          @submit.prevent="ask"
        >
          <input
            ref="input"
            v-model="question"
            class="you-should-ask__input"
            type="text"
            placeholder="Stel hier je vraag"
          >

          <button
            class="you-should-ask__button"
            type="submit"
          >
            <span>{{ $t('Submit') }}</span>
            <NuxtIcon name="icon:search" />
          </button>
        </form>
      </div>
    </div>
  </section>
</template>

<style>
@import url("~layers/components/Strapi/Slice.css");
@import url("~layers/components/Thirdparty/YouShouldAsk.css");
</style>
